import { render, staticRenderFns } from "./BaseGridIcon.vue?vue&type=template&id=0f81176d&"
import script from "./BaseGridIcon.vue?vue&type=script&lang=js&"
export * from "./BaseGridIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports